import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service'


@Component({
  selector: 'app-signout',
  templateUrl: './signout.component.html',
  styleUrls: ['./signout.component.css']
})
export class SignoutComponent implements OnInit {

  constructor(public afAuth: AuthService) {
  	afAuth.signout()
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/Joey/Desktop/testdeploy/mk2/FindMeHireMe/src/app/signout/signout.component.ts